

export function extractCountryCode(place: google.maps.places.PlaceResult): string | null {
    return place?.address_components?.find(c => c.types.includes("country") && c.short_name?.length === 2)?.short_name || null;
}
